import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        name: '首页',
        component: () =>
            import ('../views/experimentalCenter/index.vue'),
        redirect: '/experimentalCenter'
    },
    {
        path: '/login',
        name: '登录',
        component: () =>
            import ('../views/loginPage.vue'),
    },
    // 用户信息
    {
        path: '/userInfo',
        name: '用户信息',
        component: () =>
            import ('../views/userInfo/index.vue'),
    },
    {
        path: '/updateUserInfo',
        name: '用户信息',
        component: () =>
            import ('../views/userInfo/updateUserInfo.vue'),
    },
    // 我的高校
    {
        path: '/myCollege',
        name: '我的高校',
        component: () =>
            import ('../views/myCollege/index.vue'),
    },
    // 我的实验
    {
        path: '/myExperiment',
        name: '我的实验',
        component: () =>
            import ('../views/myExperiment/index.vue'),
    },
    // 实验中心
    {
        path: '/experimentalCenter',
        name: '实验中心',
        component: () =>
            import ('../views/experimentalCenter/index.vue'),
    },
    // 消息中心
    {
        path: '/news',
        name: '消息中心',
        component: () =>
            import ('../views/news/index.vue'),
    }, {
        path: '/newsDetail',
        name: '消息详情',
        component: () =>
            import ('../views/news/newsDetail.vue'),
    },
    // 学院管理
    {
        path: '/college',
        name: '学院管理',
        component: () =>
            import ('../views/college/collegeCopy.vue'),
    },
    // {
    //     path: '/studentManage',
    //     name: '学生管理',
    //     component: () =>
    //         import ('../views/college/studentManage.vue'),
    // },
    {
        path: '/studentManage',
        name: '学生列表',
        component: () =>
            import ('@/views/college/student/index'),
    },
    {
        path: '/alliance/student/edit',
        name: '编辑学生',
        component: () =>
            import ('@/views/college/student/edit'),
    },
    {
        path: '/teacherManage',
        name: '教师管理',
        component: () =>
            import ('../views/college/teacherManage.vue'),
    },
    {
        path: '/alliance/teacher/edit',
        name: '新建/编辑教师',
        component: () =>
            import ('@/views/college/teacher/edit'),
    },
    {
        path: '/alliance/teacher/:id',
        name: '授课管理',
        component: () =>
            import ('@/views/college/teacher/detail'),
        children: [{
                path: '/alliance/teacher/courses',
                name: '课程列表',
                component: () =>
                    import ('@/views/college/teacher/courses/index'),
            },
            {
                path: '/alliance/teacher/courseware',
                name: '课件列表',
                component: () =>
                    import ('@/views/college/teacher/courseware/index'),
            },
            {
                path: '/alliance/teacher/announcement',
                name: '公告列表',
                component: () =>
                    import ('@/views/college/teacher/announcement/index'),
            },
            {
                path: '/alliance/teacher/homework',
                name: '作业列表',
                component: () =>
                    import ('@/views/college/teacher/homework/index'),
            },
            {
                path: '/alliance/teacher/sublet',
                name: '授课分组',
                component: () =>
                    import ('@/views/college/teacher/sublet/index'),
            },
        ],
    },
    {
        path: '/alliance/teacher/:id/courses/edit',
        name: '课程列表编辑',
        component: () =>
            import ('@/views/college/teacher/courses/edit.vue'),
    },
    {
        path: '/alliance/teacher/:id/courseware/upload',
        name: '上传课件',
        component: () =>
            import ('@/views/college/teacher/courseware/upload.vue'),
    },
    {
        path: '/alliance/teacher/:id/announcement/edit',
        name: '编辑/新建公告',
        component: () =>
            import ('@/views/college/teacher/announcement/edit.vue'),
    },
    {
        path: '/alliance/teacher/:id/homework/edit',
        name: '编辑/新建作业',
        component: () =>
            import ('@/views/college/teacher/homework/edit.vue'),
    },
    {
        path: '/alliance/teacher/:id/homework/policyfile',
        name: 'AT作业跳转',
        component: () =>
            import ('@/views/college/teacher/homework/policyfile.vue'),
    },
    {
        path: '/alliance/teacher/:id/sublet/edit',
        name: '新增编辑授课分组',
        component: () =>
            import ('@/views/college/teacher/sublet/edit'),
    },
    {
        path: '/alliance/teacher/:id/homework/document',
        name: 'notebook',
        component: () =>
            import ('@/views/college/teacher/common/document.vue'),
    },
    {
        path: '/queryMember',
        name: '查看成员',
        component: () =>
            import ('../views/college/queryMember.vue'),
    },
    // 实验列表
    {
        path: '/experimentList',
        name: '实验列表',
        component: () =>
            import ('../views/experimentList/index.vue'),
    }, {
        path: '/addExperiment',
        name: '添加实验',
        component: () =>
            import ('../views/experimentList/addExperiment .vue'),
    }, {
        path: '/experimentListDetail',
        name: '实验详情',
        component: () =>
            import ('../views/experimentList/experimentListDetail.vue'),
    },
    {
        path: '/queryResults',
        name: '查看成绩',
        component: () =>
            import ('../views/experimentList/queryResults.vue'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router